module.exports = __webpack_public_path__ + "img/pos4-bg.300b2169.jpg";